<app-main-nav>
  <div id="main" [class.app]="isApp">
    <traverser-outlet></traverser-outlet>
  </div>
  <button mat-mini-fab color="warn" (click)="scrollTop()" class="scroll-to-top">
    <mat-icon class="material-symbols-outlined" aria-hidden="false" aria-label="Arrow top of the page">keyboard_double_arrow_up</mat-icon>
  </button>
  <app-tawk-chat *ngIf="tawkId" [id]="tawkId"></app-tawk-chat>
</app-main-nav>
